import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  cardWrapper: {
    margin: '30px 41px 0px 41px',
    height: '42em',
    // padding: '',
    padding: '30px 20px 30px 20px',
    // border: '2px solid red',
    // position: 'absolute',
    // bottom: '50px',
  },
  customDot: {
    width: 10,
    height: 10,
    margin: '0 8px',
    color: '#7F7F7F',
    opacity: 0.5,
    backgroundColor: '#7F7F7F',
    borderRadius: '50%',
    cursor: 'pointer',
  },
  customDotActive: {
    width: 20,
    height: 20,
    opacity: 1,
    margin: '0 8px',
    backgroundColor: '#F37320',
    borderRadius: '50%',
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
  },
  stepperDots: {
    alignItems: 'center',
  },
  stepperContent: {
    padding: 16,
    textAlign: 'center',
    fontSize: '16px',
    color: '#000000',
  },
  stepperLink: {
    color: '#F37320',
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  stepperNumberImg: {
    position: 'absolute',
    top: '20px',
    left: '20px',
  },
  stepperImg: {
    margin: '10px 50px',
    width: '100%',
    maxWidth: '250px',
    height: '165px',
  },
  secondaryText: {
    fontSize: '14px',
    color: '#000000',
    opacity: 0.5,
    textAlign: 'center'
  },
  headerNumber: {
    display: 'block',
    '@media (max-width: 600px)': {
      display: 'none'
    }
  },
  processCard: {
    minHeight: '360px',
    '@media (max-width: 600px)': {
      minHeight: '410px'
    }
  },
  stepperContainer: {
    boxShadow: '0px 2px 10px #3F434714',
    margin: '24px 40px',
    padding: '1px 20px 20px',
  },
  customPaper: {
    maxWidth: '700px !important'
  },
  processButton: {
    color: '#000000',
    fontWeight: 'bold',
    fontSize: '18px'
  }
}))

export { useStyles }